import { render, staticRenderFns } from "./DefaultItemMobile.vue?vue&type=template&id=24fe782a&scoped=true&"
import script from "./DefaultItemMobile.vue?vue&type=script&lang=js&"
export * from "./DefaultItemMobile.vue?vue&type=script&lang=js&"
import style0 from "./DefaultItemMobile.vue?vue&type=style&index=0&id=24fe782a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe782a",
  null
  
)

export default component.exports